import { CommonModule } from '@angular/common';
import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  CarouselComponent,
  CarouselModule,
  OwlOptions,
} from 'ngx-owl-carousel-o';
import { ButtonModule } from 'primeng/button';
@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [CommonModule, ButtonModule, CarouselModule],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class BlogComponent {
  @ViewChild('owlCarousel', { static: false }) owlCarousel!: CarouselComponent;
  cards = [
    {
      image: '/images/blog/1.png',
      title: 'Cladded Glass Broadband',
      handle: '@CladdedGlassBroadband',
      time: '12 months ago',
      text: "It's been a busy few weeks and some great progress on different expansion projects, installing pipe under driveways and some serious breaker work on rock this week. #ruralfiber #gettingitdone",
      logo: '/images/blog/2.svg',
    },
    {
      image: '/images/blog/2.png',
      title: 'Cladded Glass Broadband',
      handle: '@CladdedGlassBroadband',
      time: '12 months ago',
      text: 'Autumn days at the Alpe di Siusi 🍂🍁',
      logo: '/images/blog/2.svg',
    },
    {
      image: '/images/blog/3.png', // Use your static image
      title: 'Cladded Glass Broadband',
      handle: '@CladdedGlassBroadband',
      time: '12 months ago',
      text: 'Lorem ipsum dolor sit amet consectetur adipiscing elit, porta curabitur natoque.',
      logo: '/images/blog/2.svg',
    },
  ];

  customOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: false,
    autoplayTimeout: 2000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      500: { items: 2 },
      600: { items: 3 },
      1000: { items: 3 },
    },
  };

  handleBookNow(blogId: number) {
    console.log(`Booking for blog ID: ${blogId}`);
    // Add functionality for booking
  }
  goToNext() {
    this.owlCarousel.next();
  }

  // Custom previous button action
  goToPrev() {
    this.owlCarousel.prev();
  }
}
